export default __webpack_public_path__ + "static/media/m-01.03ea9528.png";